import { useParams, useHistory } from 'react-router-dom';
import { Skeleton } from '@material-ui/lab';
import { useSnackbar } from 'notistack';

import { useAdminGetOrderById } from '../hooks/admin-get-order-by-id.hook';
import { useAdminUpdateOrder } from '../hooks/admin-update-order.hook';
import { OrderFormView } from './components/OrderFormView.component';
import { OrderFormState, orderToFormState } from '../utils/order-to-form-state.util';
import { buildUpdateOrderPayload } from '../utils/build-update-order-payload.util';
import { resolveOrderTotalsDiscountInputs } from '../utils/resolve-order-totals-discount-inputs.util';
import { ADMIN_ORDER_APP_PATHS } from '../constants/orders-app-paths.constant';

export default function AdminUpdateOrderView() {
  const { orderId } = useParams<{ orderId: string }>();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const { order, isLoading: isLoadingOrder } = useAdminGetOrderById(orderId);
  const { updateOrder, isUpdating } = useAdminUpdateOrder();

  const isLoading = isLoadingOrder;
  if (isLoading || !order) return <Skeleton variant="text" width="100%" height={50} />;

  const initialValues: OrderFormState = orderToFormState(order);
  const shortId = order.id.slice(0, 8);
  const title = `Modification de la commande de ${order.owner.firstName} ${order.owner.lastName} (#${shortId})`;
  const totalsDiscount = resolveOrderTotalsDiscountInputs(order.offer, order.companyDiscount, order.discount);

  const handleSubmit = async (currentState: OrderFormState) => {
    const payload = buildUpdateOrderPayload(initialValues, currentState);
    if (payload === null) {
      enqueueSnackbar('Aucune modification à enregistrer', { variant: 'info' });
      return;
    }
    const updated = await updateOrder(orderId, payload);
    if (updated) history.push(ADMIN_ORDER_APP_PATHS.ORDER_DETAILS(orderId));
  };

  return (
    <OrderFormView
      mode="update"
      title={title}
      ctaLabel="Mettre à jour la commande"
      addresses={[]}
      lastOrder={null}
      totalsDiscount={totalsDiscount}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      isSubmitting={isUpdating}
    />
  );
}
